import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

import { ReactComponent as IconGatilho } from "../../assets/icons/kpisPerformance/icon-gatilho.svg";
import { ReactComponent as IconSellOut } from "../../assets/icons/kpisPerformance/icon-sellout.svg";
import { ReactComponent as IconDistribuicao } from "../../assets/icons/kpisPerformance/icon-distribuicao.svg";
import { ReactComponent as IconMarketShare } from "../../assets/icons/kpisPerformance/icon-marketshare.svg";
import { ReactComponent as IconKpisPerformance } from "../../assets/icons/kpisPerformance/icon-kpisperformance.svg";
import { ReactComponent as IconAtiginmento } from "../../assets/icons/kpisPerformance/icon-atingimento.svg";
import { ReactComponent as Gestaodainfo } from "../../assets/icons/gestaodainfo.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function KpisPerformanceDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Pontuação");
  const [selectedValueDistribuicao, setSelectedValueDistribuicao] =
    useState("Eventos");
  const [selectedValueDistribuicaoNivel1, setSelectedValueDistribuicaoNivel1] =
    useState("Resumo");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [numberCard1, setNumberCard1] = useState();
  const [numberCard2, setNumberCard2] = useState();
  const [numberCard3, setNumberCard3] = useState();
  const [numberCard4, setNumberCard4] = useState();
  const [numberCard5, setNumberCard5] = useState();
  const [numberCard6, setNumberCard6] = useState();

  const handleChange = (event) => {
    app.field("Nm_Visu_Perf").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleChangeDistribuicao = (event) => {
    app.field("Nm_Visu_Canal").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleChangeDistribuicaoNivel1 = (event) => {
    app.field("Nm_Visu_TDP").selectMatch(event.target.value, true);
    setSelectedValueDistribuicaoNivel1(event.target.value);
  };

  const getNumberforBigNumbers = useCallback(
    async (objectId, index) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          index === 1 && setNumberCard1(value);
          index === 2 && setNumberCard2(value);
          index === 3 && setNumberCard3(value);
          index === 4 && setNumberCard4(value);
          index === 5 && setNumberCard5(value);
          index === 6 && setNumberCard6(value);
        });
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_Perf")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSelectedValue(distributors?.qSelected);
      setSingleGroupView(distributors?.qSelectedCount === 1);
      getNumberforBigNumbers("eb1f0bc9-d7d0-4995-8839-31fc68286be2", 1);
      getNumberforBigNumbers("e1ab9478-1764-4b1e-bc84-6c43f81b6ffa", 2);
      getNumberforBigNumbers("4a57eb09-932f-434f-bbbe-b226ed51f9aa", 3);
      getNumberforBigNumbers("d04c7957-4935-4f7a-98ee-7a0fa13dde5b", 4);
      getNumberforBigNumbers("96ed0fb3-e004-4016-9f56-1127b2909ca0", 5);
      getNumberforBigNumbers("BTS", 6);
    }
  }, [app, selections]);

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_TDP")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSelectedValueDistribuicaoNivel1(distributors?.qSelected);
    }
  }, [app, selections]);

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_Canal")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSelectedValueDistribuicao(distributors?.qSelected);
    }
  }, [app, selections]);

  return (
    <div className="app performance">
      <div className="appContent">
        <div className="container-titles">
          <h3 style={{ margin: "26.5px 16px 18px 24px" }}>
            KPIs de Performance
          </h3>
        </div>
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Pontuação"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "27px" }}
          >
            <FormControlLabel
              value="Pontuação"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Pontuação"
            />

            <FormControlLabel
              value="Gatilho"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gatilho"
            />

            <FormControlLabel
              value="Sell out C9"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Sell out"
            />

            <FormControlLabel
              value="Distribuição TDP"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Distribuição TDP"
            />

            <FormControlLabel
              value="Market Share"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Market Share"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              <div className="adm-cards">
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gatilho",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis  informativo-one">
                    <Tooltip
                      title="Garantir atingimento de sell out da marca Jameson para habilitar resultado de todos os outros KPIs."
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -14],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Gestaodainfo />
                    </Tooltip>
                  </div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard1}
                    </p>

                    <IconGatilho />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Sell Out",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis  informativo-two">
                    <Tooltip
                      title="Atingimento da meta de vendas total do grupo de marcas prioritários por canal foco de distribuição."
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -14],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Gestaodainfo />
                    </Tooltip>
                  </div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard2}
                    </p>

                    <IconSellOut />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Distribuição TDP",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis  informativo-three">
                    <Tooltip
                      title="Atingimento da meta de TDP que considera a contagem de produtos presentes por PDV distinto em cada mês. A contagem de SKUs seguirá o sortimento obrigatório estabelecido para cada segmento de ponto de venda. No caso de eventos, será considerada Dias de Evento."
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -14],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Gestaodainfo />
                    </Tooltip>
                  </div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard3}
                    </p>

                    <IconDistribuicao />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Market Share",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis  informativo-foor">
                    <Tooltip
                      title="Atingimento do objetivo de participação de mercado por UF."
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -14],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Gestaodainfo />
                    </Tooltip>
                  </div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard4}
                    </p>

                    <IconMarketShare />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontuação Total",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard5}
                    </p>

                    <IconKpisPerformance />
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "% Ating. Pts YTD",
                  }}
                  className={"container-card-item"}
                >
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard6}
                    </p>

                    <IconAtiginmento />
                  </div>
                </Card>
              </div>

              <>
                {selectedValue !== "Distribuição TDP" &&
                  selectedValue !== "Market Share" &&
                  selectedValue !== "Sell out C9" && (
                    <div style={{ height: "75%" }} className="container-table">
                      <Card
                        app={app}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        exportContainer
                        exportTable
                        exportTableId="pmfefP"
                        header={{
                          hardTitle: selectedValue,
                        }}
                      >
                        <NativeObject
                          app={app}
                          key="pmfefP"
                          reference={{ id: "pmfefP" }}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Card>
                    </div>
                  )}

                {selectedValue === "Sell out C9" && (
                  <>
                    <FormControl className="container-form-control">
                      <RadioGroup
                        defaultValue="Eventos"
                        row
                        name="row-radio-buttons-group"
                        className="radio-group radio-group-button-export"
                        value={selectedValueDistribuicao}
                        onChange={handleChangeDistribuicao}
                      >
                        <FormControlLabel
                          value="Eventos"
                          control={
                            <Radio
                              size="small"
                              defaultChecked
                              sx={{
                                color: "#0DA9D5",
                                "&.Mui-checked": {
                                  color: "#0DA9D5",
                                },
                              }}
                            />
                          }
                          label="Eventos"
                        />

                        <FormControlLabel
                          value="On Trade"
                          control={
                            <Radio
                              size="small"
                              sx={{
                                color: "#0DA9D5",
                                "&.Mui-checked": {
                                  color: "#0DA9D5",
                                },
                              }}
                            />
                          }
                          label="On Trade"
                        />

                        <FormControlLabel
                          value="Off Trade"
                          control={
                            <Radio
                              size="small"
                              sx={{
                                color: "#0DA9D5",
                                "&.Mui-checked": {
                                  color: "#0DA9D5",
                                },
                              }}
                            />
                          }
                          label="Off Trade"
                        />
                      </RadioGroup>
                    </FormControl>

                    <div style={{ height: "75%" }} className="container-table">
                      <Card
                        app={app}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        exportContainer
                        exportTable
                        exportTableId="pmfefP"
                      >
                        <NativeObject
                          app={app}
                          key="pmfefP"
                          reference={{ id: "pmfefP" }}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Card>
                    </div>
                  </>
                )}

                {selectedValue === "Market Share" &&
                  selectedValue !== "Distribuição TDP" &&
                  selectedValue !== "Sell out C9" && (
                    <>
                      <div
                        style={{ height: "75%" }}
                        className="container-table"
                      >
                        <Card
                          app={app}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                          exportContainer
                          exportTable
                          exportTableId="pmfefP"
                        >
                          <NativeObject
                            app={app}
                            key="pmfefP"
                            reference={{ id: "pmfefP" }}
                            style={{
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </Card>
                      </div>
                    </>
                  )}

                {selectedValue === "Distribuição TDP" &&
                  selectedValue !== "Market Share" &&
                  selectedValue !== "Sell out C9" && (
                    <>
                      <FormControl className="container-form-control">
                        <RadioGroup
                          defaultValue="Resumo"
                          row
                          name="row-radio-buttons-group"
                          className="radio-group radio-group-button-export"
                          value={selectedValueDistribuicaoNivel1}
                          onChange={handleChangeDistribuicaoNivel1}
                        >
                          <FormControlLabel
                            value="Resumo"
                            control={
                              <Radio
                                size="small"
                                defaultChecked
                                sx={{
                                  color: "#0DA9D5",
                                  "&.Mui-checked": {
                                    color: "#0DA9D5",
                                  },
                                }}
                              />
                            }
                            label="Resumo"
                          />

                          <FormControlLabel
                            value="Detalhamento"
                            control={
                              <Radio
                                size="small"
                                sx={{
                                  color: "#0DA9D5",
                                  "&.Mui-checked": {
                                    color: "#0DA9D5",
                                  },
                                }}
                              />
                            }
                            label="Detalhamento"
                          />
                        </RadioGroup>
                      </FormControl>

                      {selectedValueDistribuicaoNivel1 !== "Resumo" && (
                        <FormControl className="container-form-control with-filter">
                          <RadioGroup
                            defaultValue="Eventos"
                            row
                            name="row-radio-buttons-group"
                            className="radio-group radio-group-button-export"
                            value={selectedValueDistribuicao}
                            onChange={handleChangeDistribuicao}
                          >
                            <FormControlLabel
                              value="On Trade"
                              control={
                                <Radio
                                  size="small"
                                  sx={{
                                    color: "#0DA9D5",
                                    "&.Mui-checked": {
                                      color: "#0DA9D5",
                                    },
                                  }}
                                />
                              }
                              label="On Trade"
                            />

                            <FormControlLabel
                              value="Off Trade"
                              control={
                                <Radio
                                  size="small"
                                  sx={{
                                    color: "#0DA9D5",
                                    "&.Mui-checked": {
                                      color: "#0DA9D5",
                                    },
                                  }}
                                />
                              }
                              label="Off Trade"
                            />
                          </RadioGroup>

                          <div style={{ width: " 207px" }}>
                            <NativeObject
                              key={"YUjmBbh"}
                              app={app}
                              style={{
                                height: "35px",
                                width: "207px",
                                marginRight: "6px",
                              }}
                              reference={{ label: "Mes Ano", id: "YUjmBbh" }}
                            />
                          </div>
                        </FormControl>
                      )}

                      <div
                        style={{ height: "75%" }}
                        className="container-table"
                      >
                        <Card
                          app={app}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                          exportContainer
                          exportTable
                          exportTableId="Xzmdq"
                        >
                          <NativeObject
                            app={app}
                            key="Xzmdq"
                            reference={{ id: "Xzmdq" }}
                            style={{
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </Card>
                      </div>
                    </>
                  )}
              </>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

KpisPerformanceDesktop.defaultProps = {
  app: null,
  config: {},
};

KpisPerformanceDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default KpisPerformanceDesktop;
